import { FormattedMessage, useIntl } from "react-intl";
import { Heading, Text } from "@lendcord/concord";
import { DocumentUploadSlot } from "@/features/profile/components/DocumentUploadSlot";
import { DocumentsSectionSkeleton } from "./DocumentsSectionSkeleton";
import type { ProfileDocument } from "@/app/profile/profile.types";

interface DocumentsSectionProps {
  documents: ProfileDocument[] | null;
}

export function DocumentsSection({ documents }: DocumentsSectionProps) {
  const intl = useIntl();

  if (!documents) {
    return <DocumentsSectionSkeleton />;
  }

  const panDocuments = documents.filter((document) => document.type === "PAN");
  const aadhaarFrontDocuments = documents.filter((document) => document.type === "AADHAAR_FRONT");
  const aadhaarBackDocuments = documents.filter((document) => document.type === "AADHAAR_BACK");

  return (
    <div className="flex flex-col gap-8">
      <Heading level={3}>
        <FormattedMessage id="lender.profile.uploadDocumentsHeading" />
      </Heading>

      <div className="flex flex-col gap-4">
        <Text as="p" size="sm" className="font-medium">
          <FormattedMessage id="lender.profile.documentTypePan" />
        </Text>
        <DocumentUploadSlot type="PAN" documents={panDocuments} accept="image/*" />
      </div>

      <div className="flex flex-col gap-4">
        <Text as="p" size="sm" className="font-medium">
          <FormattedMessage id="lender.profile.documentTypeAddressProof" />
        </Text>

        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <Text as="p" size="xs" variant="muted">
              <FormattedMessage id="lender.profile.documentUploadAadhaarFront" />
            </Text>
            <DocumentUploadSlot
              type="AADHAAR_FRONT"
              documents={aadhaarFrontDocuments}
              label={intl.formatMessage({ id: "lender.profile.documentUploadAadhaarFrontButton" })}
              accept="image/*"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Text as="p" size="xs" variant="muted">
              <FormattedMessage id="lender.profile.documentUploadAadhaarBack" />
            </Text>
            <DocumentUploadSlot
              type="AADHAAR_BACK"
              documents={aadhaarBackDocuments}
              label={intl.formatMessage({ id: "lender.profile.documentUploadAadhaarBackButton" })}
              accept="image/*"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
